import { isValid, parseISO } from "date-fns";

const TZ_FINANCEIRO = "America/Sao_Paulo";

function formatarYmdPtBr(ymd: string): string {
  const [y, m, d] = ymd.split("-");
  if (!y || !m || !d) return "—";
  return `${d}/${m}/${y}`;
}

function isMeiaNoiteUtc(date: Date): boolean {
  return (
    date.getUTCHours() === 0 &&
    date.getUTCMinutes() === 0 &&
    date.getUTCSeconds() === 0 &&
    date.getUTCMilliseconds() === 0
  );
}

/** Formata data de movimentação/extrato sem deslocar o dia civil. */
export function formatarDataMovimentacaoFinanceiro(
  raw: string | null | undefined,
  opts?: { comHora?: boolean },
): string {
  if (!raw?.trim()) return "—";
  const s = raw.trim();

  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) {
    return formatarYmdPtBr(s);
  }

  const parsed = parseISO(s);
  if (!isValid(parsed)) return "—";

  if (isMeiaNoiteUtc(parsed)) {
    const y = parsed.getUTCFullYear();
    const m = String(parsed.getUTCMonth() + 1).padStart(2, "0");
    const d = String(parsed.getUTCDate()).padStart(2, "0");
    return `${d}/${m}/${y}`;
  }

  if (opts?.comHora === false) {
    return parsed.toLocaleDateString("pt-BR", { timeZone: TZ_FINANCEIRO });
  }

  return parsed.toLocaleString("pt-BR", {
    timeZone: TZ_FINANCEIRO,
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

/** Formata data civil (vencimento, competência) sem deslocar o dia. */
export function formatarDataCivilFinanceiro(
  raw: string | null | undefined,
): string {
  return formatarDataMovimentacaoFinanceiro(raw, { comHora: false });
}

/** YMD civil (America/Sao_Paulo ou calendário UTC em meia-noite UTC). */
export function ymdCivilFinanceiro(
  raw: string | null | undefined,
): string | null {
  if (!raw?.trim()) return null;
  const s = raw.trim();
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return s;
  const parsed = parseISO(s);
  if (!isValid(parsed)) return null;
  if (isMeiaNoiteUtc(parsed)) {
    const y = parsed.getUTCFullYear();
    const m = String(parsed.getUTCMonth() + 1).padStart(2, "0");
    const d = String(parsed.getUTCDate()).padStart(2, "0");
    return `${y}-${m}-${d}`;
  }
  return parsed.toLocaleDateString("en-CA", { timeZone: TZ_FINANCEIRO });
}

/** Hoje no calendário de America/Sao_Paulo (yyyy-MM-dd). */
export function hojeYmdFinanceiro(): string {
  return new Date().toLocaleDateString("en-CA", { timeZone: TZ_FINANCEIRO });
}

export function diferencaDiasCivisFinanceiro(
  ymdInicio: string,
  ymdFim: string,
): number {
  const [y1, m1, d1] = ymdInicio.split("-").map(Number);
  const [y2, m2, d2] = ymdFim.split("-").map(Number);
  const a = Date.UTC(y1, m1 - 1, d1);
  const b = Date.UTC(y2, m2 - 1, d2);
  return Math.round((b - a) / (24 * 60 * 60 * 1000));
}
